import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { meetingsPausedMessageOf } from '../utils/meetings-pause';

export const ApproveEngagementMeetingProposal = createAsyncThunk(
    'engagementMeetings/approveMeetingProposal',
    async (
        {
            engagementId,
            meetingProposalId,
            paymentData,
        }: { engagementId: number; meetingProposalId: string; paymentData?: { shouldUseSavedPaymentMethod: boolean; stripePaymentMethodId: string } },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${engagementId}/MeetingScheduling/${meetingProposalId}/Approve`,
                paymentData ?? null
            );
            if (response.status !== 200 && response.status !== 204) {
                const err: any = new Error('Failed to approve meeting proposal');
                err.responseData = response.response.data;
                throw err;
            }

            createNotification(
                'Meeting proposal approved successfully.',
                'success'
            );
            return { engagementId, meetingProposalId };
        } catch (error: any) {
            
            const raw: string = (
                error?.response?.data?.title ?? error?.responseData?.title ?? ''
            ).toLowerCase();
            createNotification(
                meetingsPausedMessageOf(error) ??
                    (raw.includes('payment method')
                        ? 'Buyer does not have a saved payment method.'
                        : 'An error occurred while approving the meeting proposal.'),
                'error'
            );
            throw error;
        }
    }
);
